import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import CloseIcon from '@mui/icons-material/Close'
import { Box, Button, IconButton, Stack, Typography } from '@mui/material'

import { STORE_LINKS } from '@/constants'
import { useMobilePlatform } from '@/hooks/useMobilePlatform'
import storageService from '@/utils/storage'

const DISMISS_KEY = 'appBannerDismissed'

const AppDownloadBanner = () => {
  const { t } = useTranslation()
  const platform = useMobilePlatform()
  const [dismissed, setDismissed] = useState(() => storageService.get(DISMISS_KEY) === 'true')

  if (!platform || dismissed) return null

  const handleDismiss = () => {
    storageService.set(DISMISS_KEY, 'true')
    setDismissed(true)
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        width: '100%',
        zIndex: (theme) => theme.zIndex.snackbar,
        backgroundColor: '#222221',
        px: 1.5,
        py: 1,
      }}
    >
      <Stack alignItems={'center'} direction={'row'} spacing={1.5}>
        <IconButton
          aria-label={t('components.appBanner.dismiss')}
          onClick={handleDismiss}
          size={'small'}
          sx={{ color: '#ffffff' }}
        >
          <CloseIcon fontSize={'small'} />
        </IconButton>

        <Box
          alt={'TC Şoför'}
          component={'img'}
          src={'/pwa-192x192.png'}
          sx={{ height: 36, width: 36, borderRadius: 1 }}
        />

        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography sx={{ color: '#ffffff', fontWeight: 600, lineHeight: 1.2 }} variant={'body2'}>
            {t('components.appBanner.title')}
          </Typography>
          <Typography sx={{ color: '#bdbdbd', lineHeight: 1.2 }} variant={'caption'}>
            {t('components.appBanner.subtitle')}
          </Typography>
        </Box>

        <Button
          component={'a'}
          disableElevation
          href={STORE_LINKS[platform]}
          rel={'noopener noreferrer'}
          sx={{
            backgroundColor: '#EED484',
            color: '#222221',
            fontWeight: 600,
            flexShrink: 0,
            whiteSpace: 'nowrap',
          }}
          target={'_blank'}
          variant={'contained'}
        >
          {t('components.appBanner.action')}
        </Button>
      </Stack>
    </Box>
  )
}

export default AppDownloadBanner
